import React from 'react';
import { Alert, AlertTitle, Stack, Chip } from '@mui/material';

/**
 * Non-blocking client-side hint. Server remains source of truth.
 * Snippets are length-capped by the scanner; we never echo full PHI strings.
 */
const PhiHintBanner = ({ hits = [] }) => {
  if (!hits || hits.length === 0) return null;
  return (
    <Alert
      severity="warning"
      variant="outlined"
      sx={{
        bgcolor: '#FEF3F2',
        borderColor: '#FECDCA',
        color: '#B42318',
        '& .MuiAlert-icon': { color: '#B42318' },
      }}
      role="status"
    >
      <AlertTitle sx={{ fontWeight: 600, color: '#B42318' }}>
        This looks like patient-identifiable text.
      </AlertTitle>
      The server will block sending until it’s removed. Found:
      <Stack direction="row" spacing={0.75} sx={{ mt: 1, flexWrap: 'wrap', gap: 0.75 }}>
        {hits.slice(0, 6).map((h, i) => (
          <Chip
            key={`${h.field}-${h.pattern}-${i}`}
            size="small"
            label={`${h.field} • ${h.label}: ${h.snippet}`}
            sx={{
              bgcolor: '#FFFFFF',
              color: '#B42318',
              border: '1px solid #FECDCA',
              fontSize: 11,
              height: 22,
            }}
          />
        ))}
      </Stack>
    </Alert>
  );
};

export default PhiHintBanner;
